import { defineComponent as _defineComponent } from 'vue'
import A11yDialog from "a11y-dialog";
import type { Ref } from "vue";
import { computed, nextTick, onMounted, ref, watch } from "vue";

import { type Conversation as ConversationType } from "@/Protocol/types/Conversation";
import Conversation from "./Conversation.vue";
import Dialog from "./Dialog.vue";
import Exchange from "./Exchange.vue";
import { TwiageCase } from "@/Case/models/TwiageCase";
import { BIcon } from "bootstrap-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProtocolDialog',
  props: {
    askingQuestion: { type: Boolean },
    conversation: null,
    twiageCase: null
  },
  emits: ["new-question", "new-context"],
  setup(__props: any, { expose, emit }: { emit: ({
  (eventName: "new-question", event: { question?: string }): Promise<void>;
  (eventName: "new-context"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  askingQuestion: boolean;
  conversation: ConversationType;
  twiageCase: TwiageCase | null;
};





const protocolDialogElementRef: Ref<{ getDialog: () => A11yDialog } | null> = ref(null);

let protocolDialog: A11yDialog | undefined;

onMounted(() => {
  protocolDialog = protocolDialogElementRef?.value?.getDialog?.();
});

const hide = () => {
  protocolDialog?.hide();
};

const isInCase = computed(() => props.twiageCase?.id !== undefined);

const show = () => {
  protocolDialog?.show();

  if (isInCase.value && !props.conversation.length) {
    emit("new-question", {});
  }
};

const questionFieldName = "question";

const questionText = ref("");

expose({ hide, show });

const submit = (event: Event | KeyboardEvent) => {
  if (props.askingQuestion) return;

  if (event instanceof KeyboardEvent) {
    const form = (event.target as HTMLInputElement).form;
    if (!form) return;
    const formData = new FormData(form);
    const questionFieldValue = formData.get(questionFieldName);

    if (typeof questionFieldValue === "string") {
      emit("new-question", { [questionFieldName]: questionFieldValue });
    }
    questionText.value = "";
    return form.reset();
  }

  const formData = new FormData(event.target as HTMLFormElement);
  const questionFieldValue = formData.get(questionFieldName);

  if (typeof questionFieldValue === "string") {
    emit("new-question", { [questionFieldName]: questionFieldValue });
  }
  questionText.value = "";
  (event.target as HTMLFormElement).reset();
};

const newContext = () => {
  emit("new-context");
};

const open = ref(false);

const toggleOpen = () => {
  open.value = !open.value;
};

const aiDisclaimer =
  "The Pre-Hospital AI Protocol tool is designed to provide guidance and support, but it does not replace your professional judgment. You are responsible for ensuring that all decisions and actions taken are appropriate and align with best practices and professional standards.";

const placeholderText = computed(() => {
  if (isInCase.value) {
    return "Ask a follow up question for this case...";
  }
  return "Ask a protocol question...";
});

const conversationContainer = ref<HTMLElement | null>(null);

const scrollToBottom = async () => {
  await nextTick();
  if (conversationContainer.value) {
    conversationContainer.value.scrollTop = conversationContainer.value.scrollHeight;
  }
};

watch(
  () => props.conversation,
  async () => {
    await scrollToBottom();
  },
  { deep: true },
);

return { __sfc: true,props, emit, protocolDialogElementRef, protocolDialog, hide, isInCase, show, questionFieldName, questionText, submit, newContext, open, toggleOpen, aiDisclaimer, placeholderText, conversationContainer, scrollToBottom, Conversation, Dialog, Exchange, BIcon }
}

})